<template>
  <div class="p-4">
    <div class="row">
      <div class="col-12 mb-4" v-for="(item, i) in box" :key="i">
        <div
          class="elevation-2 radius-5 box mx-auto pointer"
          @click="$emit('filter', { id: item.id, nombre: item.nombre })"
        >
          <div class="row text-center">
            <div class="col-12 text-secondary mt-4">
              <img :src="require(`@/assets/category/${item.nombre}.svg`)" />
            </div>
            <div class="col-12 mt-2">
              {{ item.nombre }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselBox",
  props: ["box"],
};
</script>

<style lang="scss" scoped>
i {
  font-size: 55px;
}

img {
  filter: invert(79%) sepia(66%) saturate(2442%) hue-rotate(348deg)
    brightness(102%) contrast(101%);
  max-height: 60px;
}

.box {
  width: 130px;
  min-height: 130px;
}
</style>
